import { useState } from "react";
import { BellRing, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Reveal } from "../Reveal";

export default function AlertBanner() {
  const [email, setEmail] = useState("");
  const [criteres, setCriteres] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/leads", {
        kind: "alerte",
        name: "Alerte personnalisée",
        email,
        message: criteres,
        details: { criteres },
      });
      toast.success("Votre alerte personnalisée est créée. Nous vous contacterons dès qu'un bien correspond.");
      setEmail("");
      setCriteres("");
    } catch {
      toast.error("Une erreur est survenue, veuillez réessayer.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section data-testid="alert-banner-section" className="px-4 py-10 sm:px-8 lg:px-16">
      <Reveal>
        <div className="mx-auto max-w-7xl rounded-3xl border border-gold/25 bg-azur px-8 py-14 sm:px-12 lg:px-16">
          <div className="grid items-center gap-10 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full border border-gold/40 px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                <BellRing size={13} />
                Alerte sur mesure
              </span>
              <h2 className="mt-6 font-serif text-2xl font-normal tracking-tight text-sand sm:text-3xl lg:text-4xl">
                Votre bien idéal n'est pas encore chez nous ?
              </h2>
              <p className="mt-4 max-w-md font-light leading-relaxed text-sand/70">
                Faites-nous part de vos critères. Nous vous contacterons dès qu'une propriété correspondant à votre recherche entre sur le marché — y compris en off-market.
              </p>
            </div>
            <form onSubmit={submit} data-testid="alert-form" className="space-y-3">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Votre adresse email"
                data-testid="alert-email-input"
                className="w-full rounded-xl border border-white/20 bg-white/10 px-5 py-4 text-sm font-light text-white placeholder:text-white/50 outline-none backdrop-blur transition-colors focus:border-gold"
              />
              <input
                type="text"
                required
                value={criteres}
                onChange={(e) => setCriteres(e.target.value)}
                placeholder="Vos critères (ex. villa vue mer, Cannes, 4 chambres, 3 M€)"
                data-testid="alert-criteres-input"
                className="w-full rounded-xl border border-white/20 bg-white/10 px-5 py-4 text-sm font-light text-white placeholder:text-white/50 outline-none backdrop-blur transition-colors focus:border-gold"
              />
              <button
                type="submit"
                disabled={sending}
                data-testid="alert-submit"
                className="group inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gold px-6 py-4 text-sm font-medium text-azur transition-colors duration-300 hover:bg-sand disabled:opacity-60"
              >
                {sending ? "Création en cours…" : "Créer mon alerte personnalisée"}
                <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </form>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
